import { Location } from '@angular/common';
import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler extends ErrorHandler {
  // rendererror occures after every viewrendering,
  // to prevent dosing the same log entry we track the previously sent one
  previousLoggedError?: string;

  constructor(
    private loggerService: LoggerService,
    private location: Location
  ) {
    super();
  }

  override handleError(error: Error): void {
    if (error instanceof Error && this.previousLoggedError !== error?.toString()) {
      this.previousLoggedError = error?.toString();
      this.loggerService.logError(error?.toString(), this.location.path(), error.stack).subscribe();
    }

    super.handleError(error);
  }
}
